export default __webpack_public_path__ + "static/media/bsc.f89639a5.svg";